import React from 'react';
import WitnessListItem from './WitnessListItem';

type Props = {
    witnesses: any[];
    searchQuery?: string;
    reloadWitnesses?: () => void;
    userWitnessVotes?: string[];
};

export const WitnessesList = ({ witnesses, searchQuery = "", reloadWitnesses, userWitnessVotes = [] }: Props) => {
    // Filter witnesses based on the search query
    const filteredWitnesses = witnesses.filter((witness) =>
        witness.owner.toLowerCase().includes(searchQuery.toLowerCase())
    );

    return (
        <div className="w-100">
            {filteredWitnesses.length > 0 ? (
                filteredWitnesses.map((witness) => {
                    // Find the closest ACTIVE witness above in the global list to calculate distance
                    const globalIndex = witnesses.findIndex(w => w.owner === witness.owner);
                    let witnessAbove = null;
                    
                    // Search backwards for the first witness with a rank (active)
                    for (let i = globalIndex - 1; i >= 0; i--) {
                        if (witnesses[i].rank !== null) {
                            witnessAbove = witnesses[i];
                            break;
                        }
                    }

                    return (
                        <React.Fragment key={witness.owner}>
                            <WitnessListItem 
                                witness={witness} 
                                witnessAbove={witnessAbove}
                                style={{ marginBottom: '15px' }} 
                                reloadWitnesses={reloadWitnesses}
                                userWitnessVotes={userWitnessVotes}
                            />
                            {witness.rank === 20 && (
                                <div className="my-4 position-relative d-flex align-items-center justify-content-center">
                                    <hr className="w-100" style={{ borderTop: '2px solid var(--speem)', opacity: 0.3 }} />
                                     
                                </div>
                            )}
                        </React.Fragment>
                    );
                })
            ) : (
                <div className="text-center text-muted p-5">
                    No witnesses found matching your search.
                </div>
            )}
        </div>
    );
};

export default WitnessesList;
